<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white">
        <div class="w-16 border-l border-t border-b border-gray-200 border-gray-200 flex -my-px bg-white">
            <div
                class="whitespace-pre-line w-full text-sm m-0 my-px px-2 py-1 text-gray-900 border-gray-200 shadow-none relative focus:z-10"
                v-text="reference"
            ></div>
        </div>
        <!-- Description. -->
        <div
            class="flex-1 relative flex border-l border-t border-b border-gray-200 border-gray-200 flex -my-px bg-white">
            <div
                class="whitespace-pre-line text-sm w-full -ml-px -my-px px-2 pt-1.5 pb-0 min-h-[30px] shadow-none relative resize-none "
                ref="descLine"
                :class="!opened?'max-h-[30px] overflow-hidden':'pb-1.5'"
                v-text="description"
            ></div>
            <div class="absolute right-2 top-0 z-20" v-if="canBeOpened">
                <div class="text-xs text-gray-600 w-full m-0 pt-2 opacity-25 hover:opacity-100"
                     @click="toggleOpened">
                    <i class="fa fa-eye"></i>
                </div>
            </div>
        </div>
        <!-- Quantity. -->
        <div class="w-24 border-l border-t border-b border-gray-200 border-gray-200 flex -my-px bg-white">
            <div
                class="whitespace-pre-line text-sm w-full m-0 my-px px-2 pt-1 shadow-none relative resize-none"
                v-text="quantity"
            ></div>
        </div>
        <!-- Item Value. -->
        <div class="w-20 border-l border-t border-b border-gray-200 -my-px flex" :class="bgClass(item.complete)">
            <div
                class="whitespace-pre-line text-gray-500 text-xs w-full m-0 my-0 px-0.5 py-1.5 shadow-none relative resize-none"
                v-text="item.value"
            ></div>
        </div>
        <!-- Percent Complete -->
        <div class="w-20 border-l border-t border-b border-gray-200 -my-px flex" :class="bgClass(item.complete)"
             v-if="measurable">
            <div
                class="whitespace-pre-line text-gray-500 text-xs w-full m-0 my-0 px-0.5 py-1.5 shadow-none relative resize-none"
                v-text="item.complete"
            ></div>
        </div>
        <!-- Apply For Percent -->
        <div class="w-24 -ml-px flex" v-if="measurable">
            <page-cell
                class="text-xs text-right text-gray-500 -ml-px -my-px px-0.5 py-1.5 border"
                :class="bgClass(item.applyingForPercent) + (readonly?' border-gray-200':' border-gray-300')"
                :read-only="readonly"
                placeholder="..."
                v-model="item.applyingForPercent"
                @input="updatePercent"
                @change="finishedPercent"
            ></page-cell>
        </div>
        <!-- Applying for -->
        <div class="w-24 -ml-px flex">
            <page-cell
                class="text-xs text-right text-gray-500 -ml-px -my-px px-0.5 py-1.5 border"
                :class="bgClass(item.applyingForPercent) + (readonly?' border-gray-200':' border-gray-300')"
                :read-only="readonly"
                placeholder="£..."
                v-model="item.applyingFor"
                @input="updateValue"
                @change="finishedValue"
            ></page-cell>
        </div>
    </div>
</template>

<script>

import {resolveNumericText, toCurrency} from "../../../utils";
import UiDropdown from "../../ui/UiDropdown.vue";
import PageCell from "../../ui/PageCell.vue";
import * as math from "mathjs";

export default {
    components: {PageCell, UiDropdown},
    props: {
//        section: Object,
        task: Object,
        item: Object,
        readonly: Boolean,
        measurable: Boolean,
    },
    data() {
        let value = resolveNumericText(this.item.value)
        return {
            reference: this.item.reference,
            description: this.item.description,
            quantity: this.item.quantity,
            itemMinPercent: 0,
            itemMaxPercent: 100,
            math,
            opened: false,
            canBeOpened: false,
        }
    },
    computed: {},
    methods: {
        bgClass(op) {
            if (!this.measurable || resolveNumericText(op) === 0) {
                return 'bg-white'
            } else if (resolveNumericText(op) === 100) {
                return 'bg-green-100'
            } else {
                return 'bg-orange-100'
            }
        },
        updatePercent(value) {
            let v = math.round(math.min(100, math.max(0, resolveNumericText(value))), 2);
            this.item.applyingFor = toCurrency((resolveNumericText(this.item.value) / 100) * v);
            this.$forceUpdate()
        },
        finishedPercent(value) {
            let v = math.round(math.min(100, math.max(0, resolveNumericText(value))), 2);
            this.item.applyingFor = toCurrency((resolveNumericText(this.item.value) / 100) * v);
            this.item.applyingForPercent = v + '%';
            this.$forceUpdate()
            this.$emit('updated')
        },
        updateValue(value) {
            let iv = resolveNumericText(this.item.value)
            let v = math.round(math.max(0, math.min((this.measurable ? iv : Infinity), resolveNumericText(value))), 2)
            this.item.applyingForPercent = (iv ? math.round(((v / iv) * 100), 2) : 100) + '%'
            this.$forceUpdate()
        },
        finishedValue(value) {
            let iv = resolveNumericText(this.item.value)
            let v = math.round(math.max(0, math.min((this.measurable ? iv : Infinity), resolveNumericText(value))), 2)
            this.item.applyingFor = toCurrency(v);
            this.item.applyingForPercent = (iv ? math.round(((v / iv) * 100), 2) : 100) + '%'
            this.$forceUpdate()
            this.$emit('updated')
        },
        toggleOpened() {
            this.opened = !this.opened;
        },
    },
    mounted() {
        this.canBeOpened = math.round(this.$refs.descLine.scrollHeight) > math.round(this.$refs.descLine.getBoundingClientRect().height)
    }
}
</script>
